module.exports = __webpack_public_path__ + "img/s6.cf214e7e.svg";